import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useCallback } from "react";
import {
  PREFECTURE_LIST,
  SLEEP_HOSPITAL_PREFECTURE_LIST,
} from "./SleepHospital";

export const NO_SELECT = "指定しない";

const SELECT_PREFECTURE_LIST = [NO_SELECT, ...PREFECTURE_LIST] as const;
/** 表示エリアの選択肢 */
export type SelectPrefecture = (typeof SELECT_PREFECTURE_LIST)[number];
const SELECT_SLEEP_HOSPITAL_PREFECTURE_LIST = [
  NO_SELECT,
  ...SLEEP_HOSPITAL_PREFECTURE_LIST,
];

/**
 * 選択された都道府県
 */
export interface SelectedPrefecture {
  /** 選択された都道府県 */
  prefecture: SelectPrefecture;
  /** 検索可能フラグ */
  searchable: boolean;
}

const SELECTABLE_PREFECTURE_LIST = SELECT_PREFECTURE_LIST.map((p) => ({
  prefecture: p,
  searchable: SELECT_SLEEP_HOSPITAL_PREFECTURE_LIST.includes(p),
}));

/**
 * {@link PrefectureSelect} のプロパティ
 */
export interface PrefectureSelectProps {
  value: SelectedPrefecture;
  onChange: (
    selectedPrefecture: SelectedPrefecture,
    event: SelectChangeEvent<SelectPrefecture>
  ) => void;
}

/**
 * 表示エリアセレクトボックス
 *
 * @param {@link PrefectureSelectProps}
 * @returns 表示エリアセレクトボックス
 */
export default function PrefectureSelect({
  value,
  onChange,
}: PrefectureSelectProps) {
  const handleChange = useCallback(
    (event: SelectChangeEvent<SelectPrefecture>) => {
      onChange(
        {
          prefecture: event.target.value as SelectPrefecture,
          searchable: SELECT_SLEEP_HOSPITAL_PREFECTURE_LIST.includes(
            event.target.value
          ),
        },
        event
      );
    },
    [onChange]
  );
  return (
    <FormControl fullWidth size="medium" variant="outlined">
      <InputLabel id="area-select-label">表示エリア</InputLabel>
      <Select
        labelId="area-select-label"
        id="area-select"
        value={value.prefecture}
        onChange={handleChange}
        label="表示エリア"
        displayEmpty
      >
        {SELECTABLE_PREFECTURE_LIST.map((v, i) => (
          <MenuItem value={v.prefecture} key={i} disabled={!v.searchable}>
            {v.prefecture}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
